module.exports = __webpack_public_path__ + "img/tutorial-center.39a2f494.png";